import type { JSX } from 'react';

import type { TranslationPluralKey } from '@change-corgi/core/i18n';

import type { JsxReplacements, TranslateHtmlOptions } from '../misc';
import { useI18n } from '../misc';

type Props = Readonly<{
	value: string;
	count: number;
	replacements?: JsxReplacements;
}> &
	TranslateHtmlOptions;

export function TranslatePluralHtml({ value, count, replacements, ...options }: Props): JSX.Element {
	const { translatePluralHtml } = useI18n();

	return <>{translatePluralHtml(value, count, replacements, options)}</>;
}

type TypedProps = Readonly<{
	value: TranslationPluralKey;
	count: number;
	replacements?: JsxReplacements;
}> &
	TranslateHtmlOptions;

export function TypedTranslatePluralHtml({ value, count, replacements, ...options }: TypedProps): JSX.Element {
	const { typedTranslatePluralHtml } = useI18n();

	return <>{typedTranslatePluralHtml(value, count, replacements, options)}</>;
}
